import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import withAuthorization from '../../hoc/withAuthorization';
import LargePaper from '../../components/Layout/LargePaper';
import stylesDefault from '../../constants/stylesDefault';
import {getDashboardDatas, getLateRents} from '../../store/dashboardDatas/actions';
import { getRoles } from '../../store/roles/actions';
import { getRenters } from '../../store/renters/actions';
import { getSites } from '../../store/sites/actions';
import Dashboard from '../../components/Dashboard/Dashboard';
import Loader from '../../components/Layout/Loader';
import { getBikes } from '../../store/bikes/actions';
import { ROLE_USER } from '../../constants/roles';

export class DashboardPage extends Component {
  state = {
    role: ROLE_USER,
  };

  static getDerivedStateFromProps(props) {
    let newState = null;
    if (props.authUser && props.roles) {
      const role = props.roles[props.authUser.uid];
      newState = { ...newState, role };

      if (
        !props.dashboardDatas
        && !props.pendingDashboardDatas
        && !props.errorDashboardDatas
      ) {
        props.getDashboardDatas(props.authUser.ma, role);
      }
      if (
        !props.bikes
        && !props.pendingBikes
        && !props.errorBikes
      ) {
        props.getBikes(props.authUser.ma, role);
      }
      if (
        !props.renters
        && !props.pendingRenters
        && !props.errorRenters
      ) {
        props.getRenters(props.authUser.ma, role);
      }
      if (
        !props.sites
        && !props.pendingSites
        && !props.errorSites
      ) {
        props.getSites(props.authUser.ma, role);
      }
      if (
        !props.rents
        && !props.pendingRents
        && !props.errorRents
      ) {
        props.getLateRents(props.authUser.ma, role);
      }
    }
    return newState;
  }

  render() {
    let dashboard;
    if (this.props.pending) {
      dashboard = <Loader/>;
    } else if (this.props.dashboardDatas
      && this.props.bikes
      && this.props.renters
      && this.props.sites
      && this.props.rents) {
      dashboard = <Dashboard dashboardDatas={this.props.dashboardDatas}
                             renters={this.props.renters}
                             bikes={this.props.bikes}
                             sites={this.props.sites}
                             rents={this.props.rents}
                             role={this.state.role}
      />;
    }
    return (
      <LargePaper>
        <h1 style={stylesDefault.title}>Dashboard</h1>
        {dashboard}
      </LargePaper>
    );
  }
}

const authCondition = authUser => !!authUser;

const mapStateToProps = state => ({
  authUser: state.users.authUser,
  roles: state.roles.content,
  dashboardDatas: state.dashboardDatas.content,
  renters: state.renters.content,
  bikes: state.bikes.content,
  sites: state.sites.content,
  rents: state.dashboardDatas.late_rents,
  pending: state.roles.pending
  || state.dashboardDatas.pending
  || state.renters.pending
  || state.bikes.pending
  || state.sites.pending
  || state.rents.pending,
  pendingDashboardDatas : state.dashboardDatas.pending,
  pendingRenters: state.renters.pending,
  pendingBikes: state.bikes.pending,
  pendingSites: state.sites.pending,
  pendingRents: state.dashboardDatas.pending,
  errorDashboardDatas : state.dashboardDatas.error,
  errorRenters: state.renters.error,
  errorBikes: state.bikes.error,
  errorSites: state.sites.error,
  errorRents: state.dashboardDatas.error,
});

export default compose(
  withAuthorization(authCondition),
  connect(mapStateToProps, {
    getDashboardDatas, getRoles, getRenters, getBikes, getSites, getLateRents
  }),
)(DashboardPage);



// WEBPACK FOOTER //
// ./src/containers/DashboardPage/DashboardPage.jsx